import "odometer/themes/odometer-theme-minimal.css";

import Odometer from "odometer";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.odometerOptions = {
    auto: false,
    format: "(.ddd),dd",
};

export default function initGsapOdometer() {
    function gsapOdometer(el) {
        const odometerFrom = el.dataset.odometerFrom;
        const odometerFormat = el.dataset.odometerFormat;

        if (!el.dataset.odometerTo)
            el.dataset.odometerTo = el.textContent.trim();

        new Odometer({
            el: el,
            value: odometerFrom,
            format: odometerFormat,
        });

        el.textContent = el.dataset.odometerTo;
    }

    const elements = document.querySelectorAll('.odometer, [lang="odometer"]');

    elements.forEach((el) => {
        ScrollTrigger.create({
            trigger: el,
            onEnter: () => gsapOdometer(el),
            onLeaveBack: () => (el.textContent = el.dataset.odometerFrom || 0),
        });
    });
}
